import { defineMessages } from 'react-intl'

export default defineMessages({
  profile: {
    id: 'session.profile',
    defaultMessage: 'Profile',
  },
  activityListNotificationsHeading: {
    id: 'session.activitylist.notifications.heading',
    defaultMessage: 'Notifications',
  },
  noNewNotifications: {
    id: 'session.activities.empty',
    defaultMessage: `You have no new notifications.`,
  },
  completeProfileTitle: {
    id: 'session.complete.profile.title',
    defaultMessage: `Complete Your Profile`,
  },
  completeProfileHint: {
    id: 'session.complete.profile.hint',
    defaultMessage: `You can edit these details later`,
  },
  profileSaveFailureAlert: {
    id: 'session.profile.save.failure.alert',
    defaultMessage: 'Failed to save your profile',
  },
  profileFieldDisplayName: {
    id: 'session.profile.form.displayName',
    defaultMessage: `Display Name`,
  },
  profileFieldName: {
    id: 'session.profile.form.name',
    defaultMessage: `Full Name`,
  },
  profileFieldUsername: {
    id: 'session.profile.form.username',
    defaultMessage: `Username`,
  },
  profileFieldPassword: {
    id: 'session.profile.form.password',
    defaultMessage: `New Password`,
  },
  profileNoPhoto: {
    id: 'session.profile.not.photo',
    defaultMessage: `No photo handy?`,
  },
  profileUseLink: {
    id: 'session.profile.use.link',
    defaultMessage: `Use {link}`,
  },
  profileNetworkPic: {
    id: 'session.profile.network.pic',
    defaultMessage: `{network} Profile Pic`,
  },
  profileDone: {
    id: 'session.profile.done',
    defaultMessage: `Done`,
  },
  profileDisclaimer: {
    id: 'session.profile.disclaimer',
    defaultMessage: `By continuing you are accepting the Pressly {termsLink} and {privacyLink}`,
  },
  profileTerms: {
    id: 'session.terms',
    defaultMessage: `Terms`,
  },
  profilePrivacy: {
    id: 'session.privacy',
    defaultMessage: `Privacy`,
  },
  profileAddProfileImage: {
    id: 'session.profile.add.image',
    defaultMessage: `Add Profile Image`,
  },
  signInDisclaimer: {
    id: 'session.signin.disclaimer',
    defaultMessage: `By continuing you are accepting the {termsLink} and {privacyLink}.`,
  },
  continueSignInWith: {
    id: 'session.signin.continue.with',
    defaultMessage: `Sign in with {networkName}`,
  },
  continueJoinWith: {
    id: 'session.join.continue.with',
    defaultMessage: `Continue with {networkName}`,
  },
  signUpWithEmail: {
    id: 'session.signup.with.email',
    defaultMessage: `Sign up with email`,
  },
  signUpDisclaimer: {
    id: 'session.signup.disclaimer',
    defaultMessage: `By continuing you are accepting the Pressly {termsLink} and {privacyLink}.`,
  },
  resetPasswordTitle: {
    id: 'session.form.reset.password.title',
    defaultMessage: `Reset Password`,
  },
  newPasswordLabel: {
    id: 'session.form.new.password.label',
    defaultMessage: `New Password`,
  },
  confirmNewPasswordLabel: {
    id: 'session.form.confirm.password.label',
    defaultMessage: `Confirm New Password`,
  },
  errorPasswordLength: {
    id: 'session.error.password.length',
    defaultMessage: `Must be greater than 8 characters`,
  },
  errorPasswordMismatch: {
    id: 'session.error.password.mismatch',
    defaultMessage: `Passwords do not match`,
  },
  passwordChangeSuccessMessage: {
    id: 'session.password.change.success.message',
    defaultMessage: 'Password changed successfully',
  },
  activityLiked: {
    id: 'common.activity.liked',
    defaultMessage: 'liked',
  },
  activityCommentedOn: {
    id: 'common.activity.commented.on',
    defaultMessage: 'commented on',
  },
  activityMentionedYouIn: {
    id: 'common.activity.mentioned.you.in',
    defaultMessage: 'mentioned you in',
  },
  activityAPost: {
    id: 'activity.a.post',
    defaultMessage: 'a post',
  },
  notificationSettingsHeader: {
    id: 'notification.settings.header',
    defaultMessage: 'Notification Settings',
  },
  notificationsOptInReceiveCommunity: {
    id: 'notification.settings.receive.community',
    defaultMessage: 'I want to receive newsletters from this community',
  },
  notificationOptInActivities: {
    id: 'notifications.settings.receive.posts',
    defaultMessage: 'I want to receive notifications from activities on my posts and comments',
  },
  emailSignInEmailPlaceholder: {
    id: 'email.sign.in.email.placeholder',
    defaultMessage: 'Email or Username',
  },
  hubSidebarFilterHubs: {
    id: 'hub.sidebar.filter.hubs',
    defaultMessage: 'Filter Hubs',
  },
  hubSidebarEmptyMessage: {
    id: 'hub.sidebar.empty.message',
    defaultMessage: 'No hubs found',
  },
  forgotPassword: {
    id: 'forgotpassword.title',
    defaultMessage: 'Forgot Password?',
  },
  forgotPasswordHeader: {
    id: 'forgotpassword.header.1',
    defaultMessage: 'Please enter your email address below to reset your password.',
  },
  magicLinkHeader: {
    id: 'magic.link.header',
    defaultMessage: 'Trouble signing in?',
  },
  magicLinkSuccessMessage1: {
    id: 'magic.link.success.message.1',
    defaultMessage: 'The sign-in link has been successfully emailed to you.',
  },
  magicLinkSuccessMessage2: {
    id: 'magic.link.success.message.2',
    defaultMessage: 'It will expire within 24 hours.',
  },
  signIntoOrg: {
    id: 'session.sign.in.to',
    defaultMessage: 'Sign into {organizationName}',
  },
  mustSignInMsg: {
    id: 'session.must.sign.in',
    defaultMessage: 'You must sign in to continue',
  },
  signInWithEmail: {
    id: 'session.sign.in.with.email',
    defaultMessage: 'Sign in with Email',
  },
  signInWithAccount: {
    id: 'session.sign.in.with.account',
    defaultMessage: 'Or sign in with your account',
  },
  signInAlreadyHaveAccount: {
    id: 'session.already.have.account',
    defaultMessage: 'Already have an account?',
  },
  me: {
    id: 'session.create.hub.me',
    defaultMessage: 'Me',
  },
  selectOrganizationLabel: {
    id: 'session.create.hub.select.organization.label',
    defaultMessage: 'Select Organization',
  },
  createNewHubHeader: {
    id: 'session.create.hub.header',
    defaultMessage: 'Create a New Hub',
  },
  createNewHubTagline: {
    id: 'session.create.hub.tagline',
    defaultMessage:
      'What connects your community or team? International diplomacy, burger recipes or cat videos...',
  },
  createNewHubNameLabel: {
    id: 'session.create.hub.label',
    defaultMessage: 'Hub name',
  },
  createNewHubNamePlaceholder: {
    id: 'session.create.hub.placeholder',
    defaultMessage: 'Enter your Hub name',
  },
  createNewHubVisibilityHint: {
    id: 'session.create.hub.viz.hint',
    defaultMessage: 'The new Hub will accessible by all members of this account',
  },
  publicHubTitle: {
    id: 'session.hub.public.title',
    defaultMessage: 'Public Hub',
  },
  publicHubDescription: {
    id: 'session.hub.public.description',
    defaultMessage: 'Anyone can search and find this Hub',
  },
  privateHubTitle: {
    id: 'session.hub.private.title',
    defaultMessage: 'Private Hub',
  },
  privateHubDescription: {
    id: 'session.hub.private.description',
    defaultMessage:
      'Only invited user can view this Hub. Visible in organization hub listings and members of an organization may request to join.',
  },
  createHubAction: {
    id: 'session.create.hub.action',
    defaultMessage: 'Create Hub',
  },
  errorsInvalidUID: {
    id: 'session.hub.errors.invalid.uid',
    defaultMessage: 'Invalid UID',
  },
  errorsUIDTaken: {
    id: 'session.hub.errors.uid.taken',
    defaultMessage: 'UID already taken',
  },
  errorPasswordCriteria: {
    id: 'session.error.password.criteria',
    defaultMessage: `Please enter a password that is 8 or more characters long containing at least one number, one uppercase letter and one lowercase letter.`,
  },
  createOrgHeading: {
    id: 'session.create.org.heading',
    defaultMessage: 'Create Organization',
  },
  createOrgSubmitText: {
    id: 'session.create.org.submit.text',
    defaultMessage: 'Create Organization',
  },
  createOrgDescription: {
    id: 'session.create.org.description',
    defaultMessage:
      'An organization houses hubs of content. It is a place for your community or company to organize its hubs.',
  },
  createOrgTeamName: {
    id: 'session.create.org.team.name',
    defaultMessage: 'Team Name',
  },
  createOrgOrgNamePlaceholder: {
    id: 'session.create.org.name.placeholder',
    defaultMessage: 'organization-name',
  },
  createOrgDescriptionLabel: {
    id: 'session.create.org.description.label',
    defaultMessage: 'Description',
  },
  changePasswordHeading: {
    id: 'session.change.password.heading',
    defaultMessage: 'Change Password',
  },
  changeYourPasswordHeading: {
    id: 'session.change.your.password.heading',
    defaultMessage: 'Change Your Password',
  },
  changePasswordUnsentErrorMessage: {
    id: 'session.change.password.unsent.error.message',
    defaultMessage: 'You can choose a new password for your account here',
  },
  reEnterPassword: {
    id: 'session.change.password.re.enter.password',
    defaultMessage: 'Re-enter Password',
  },
  enterPasswordToAccept: {
    id: 'session.change.password.enter.to.accept',
    defaultMessage: 'Enter the password for your {account} account',
  },
  changePasswordSubmit: {
    id: 'session.change.password.submit',
    defaultMessage: 'Change My Password',
  },
  failedHubJoinAlert: {
    id: 'session.join.hub.failed.alert',
    defaultMessage: 'Failed to join hub',
  },
  hubJoinMessage: {
    id: 'session.join.hub.message',
    defaultMessage: 'You have been invited to join {hubName}',
  },
  passwordResetSuccessHeading: {
    id: 'session.password.reset.heading',
    defaultMessage: 'Reset Instructions Sent',
  },
  emailedPasswordInstructionsTo: {
    id: 'session.password.emailed.instructions.to',
    defaultMessage: "We've emailed password reset instructions to: {email}",
  },
  resetYourPassword: {
    id: 'session.reset.your.password',
    defaultMessage: 'Reset Your Password',
  },
  resetPasswordInstructionsSentSuccessfully: {
    id: 'reset.password.instruction.sent',
    defaultMessage: 'Reset password instructions sent.',
  },
  resetPasswordExpireIn24Hours: {
    id: 'reset.password.instruction.expiretime',
    defaultMessage: 'It will expire within 24 hours.',
  },
  resetMyPassword: {
    id: 'session.reset.my.password',
    defaultMessage: 'Reset My Password',
  },
  resetPasswordInstruction: {
    id: 'session.reset.password.instruction',
    defaultMessage:
      "Enter your account's email address, and we'll send you instructions on how to reset your password.",
  },
  resetPasswordError: {
    id: 'session.reset.password.error',
    defaultMessage: 'Could not reset password for this email address.',
  },
  alreadyResetPassword: {
    id: 'session.already.reset.password',
    defaultMessage: 'Already reset your password?',
  },
  invalidUsername: {
    id: 'session.user.profile.username.invalid.error',
    defaultMessage: 'Invalid Username',
  },
  usernameAlreadyTaken: {
    id: 'session.user.profile.username.taken.error',
    defaultMessage: 'Username is already taken',
  },
  generalLoginError: {
    id: 'session.auth.general.login.error',
    defaultMessage: 'There was a problem logging you in',
  },
  generalServerError: {
    id: 'session.server.general.error',
    defaultMessage: 'Something went wrong',
  },
  asRole: {
    id: 'session.user.as.a.role',
    defaultMessage: ' as a {role}',
  },
  requestedToJoin: {
    id: 'session.requested.to.join',
    defaultMessage: '{userName} requested to join {orgHubName} as a {role}',
  },
  acceptedInvite: {
    id: 'session.accepted.invite',
    defaultMessage: '{userName} joined {orgHubName} as a {role}',
  },
  rejectedInvite: {
    id: 'session.rejected.invite',
    defaultMessage: '{userName} rejected the request to join {orgHubName} as a {role}',
  },
  orgadminApprovedRole: {
    id: 'session.orgadmin.approved.role',
    defaultMessage: `{userName} is now a {role} on {orgName}`,
  },
  orgadminRejectRole: {
    id: 'session.orgadmin.reject.role',
    defaultMessage: `{userName}'s request to become an {role} on {orgName} was rejected`,
  },
  pendingMessage: {
    id: 'session.invite.pending.message',
    defaultMessage: '{user} invited you to join {orgHubName} as a {role}',
  },
  joinMessage: {
    id: 'session.join.message',
    defaultMessage: '{user} joined {orgHubName} as a {role}',
  },
  rejectInvitationMessage: {
    id: 'session.reject.message',
    defaultMessage: '{user} rejected the invitation to join {orgHubName} as a {role}',
  },
  postCommentNotification: {
    id: 'session.post.comment.notification',
    defaultMessage: '{user} commented on {post}',
  },
  postLikeNotification: {
    id: 'session.post.like.notification',
    defaultMessage: '{user} liked {post}',
  },
  userMentionNotification: {
    id: 'session.user.mention.notification',
    defaultMessage: '{user} mentioned you in {postOrComment}',
  },
  authenticateAcceptInvite: {
    id: 'session.user.accept.invite',
    defaultMessage: 'Authenticate to accept invite',
  },
  wrongCredentials: {
    id: 'session.user.wrong.credentials',
    defaultMessage: 'The credentials you entered are incorrect. Please try again.',
  },
  hubEmailFormInstruction: {
    id: 'session.hub.email.instruction',
    defaultMessage: "Enter your email address and we'll help you sign in",
  },
  hubPasswordFormInstruction: {
    id: 'session.hub.password.instruction',
    defaultMessage: 'Enter password for {hubName}',
  },
  orgEmailFormInstruction: {
    id: 'session.org.email.instruction',
    defaultMessage: "Enter the email address for your {orgName} account and we'll help you sign in",
  },
  orgPasswordFormInstruction: {
    id: 'session.org.password.instruction',
    defaultMessage: 'Enter the password for your {orgName} account',
  },
  signIn: {
    id: 'session.sign.in',
    defaultMessage: 'Sign In',
  },
  sparqAdminSSO: {
    id: 'session.sparq.admin.sso',
    defaultMessage:
      'Sparq admins are required to authenticate into the hub community through Sparq 3. Please navigate to Sparq 3 and sign in with your credentials there.',
  },
  joinTheCommunity: {
    id: 'session.join.the.community',
    defaultMessage: 'Join the {hubName} Community',
  },
  havingTroubleSigningIn: {
    id: 'session.having.trouble.signing.in',
    defaultMessage: 'Having trouble signing in?',
  },
  orSignIn: {
    id: 'session.or.sign.in',
    defaultMessage: 'or Sign In',
  },
  cantAuthenticateHere: {
    id: 'session.cant.authenticate.here',
    defaultMessage: "Can't authenticate here with those credentials",
  },
  changePasswordInstructions: {
    id: 'session.change.password.instructions',
    defaultMessage:
      'Click "Edit" to change your account password. You\'ll be required to re-enter your current password.',
  },
  currentPassword: {
    id: 'session.current.password',
    defaultMessage: 'Current Password',
  },
  orgResetPasswordDescription: {
    id: 'session.reset.password.org.description',
    defaultMessage:
      "Enter the email you use for your {orgName} account and we'll help you reset your password.",
  },
  hubResetPasswordDescription: {
    id: 'session.reset.password.hub.description',
    defaultMessage:
      "Enter the email you use for your {hubName} account and we'll help you reset your password.",
  },
  closeResetPassword: {
    id: 'session.reset.password.close',
    defaultMessage: 'I remembered my password',
  },
  closeResetPasswordSent: {
    id: 'session.reset.password.close.sent',
    defaultMessage: 'Return to login',
  },
  magicLinkSuccessHeader: {
    id: 'session.reset.password.sent.title',
    defaultMessage: 'Email Sent',
  },
  magicLinkSuccessBody: {
    id: 'session.reset.password.sent.body',
    defaultMessage:
      'An email has been sent to {email} with instructions on how to reset your password.',
  },
  resetPasswordFormDescription: {
    id: 'session.reset.password.form.description',
    defaultMessage: 'Use the form below to reset the password for your {name} account',
  },
  resetPasswordFormTitle: {
    id: 'session.reset.password.form.title',
    defaultMessage: 'Reset Password',
  },
  passwordRequirements: {
    id: 'session.reset.password.form.requirements',
    defaultMessage: 'Password Requirements',
  },
  passwordResetSuccessTitle: {
    id: 'session.reset.password.success.title',
    defaultMessage: 'Password Reset',
  },
  passwordResetSuccessBody: {
    id: 'session.reset.password.success.body',
    defaultMessage: "You've successfully reset your password",
  },
  ariaLabelClose: {
    id: 'session.reset.password.success.aria.close',
    defaultMessage: 'Close the password success dialog',
  },
  passwordResetErrorTitle: {
    id: 'session.reset.password.error.title',
    defaultMessage: 'Password Reset Link Expired',
  },
  passwordResetErrorBody: {
    id: 'session.reset.password.error.body',
    defaultMessage: 'The password reset link you requested has now expired or become invalid',
  },
  passwordResetErrorLink: {
    id: 'session.reset.password.error.link',
    defaultMessage: 'Click here to try again',
  },
  passwordResetBackLink: {
    id: 'session.reset.password.back.link',
    defaultMessage: 'Back',
  },
  newPassword: {
    id: 'session.reset.password.new.password',
    defaultMessage: 'New Password',
  },
  generalErrorTitle: {
    id: 'session.reset.password.error.general.title',
    defaultMessage: 'Error',
  },
  alreadyUsedLink: {
    id: 'session.unlock.link',
    defaultMessage: 'Sorry, this link was used already',
  },
  tryAgain: {
    id: 'session.unlock.try',
    defaultMessage: 'The link provided for account unlock is no longer valid',
  },
  sessionUnlockTitle: {
    id: 'session.unlock.title',
    defaultMessage: 'Link was already used',
  },
  notMember: {
    id: 'session.email.not.member',
    defaultMessage: 'Not a member?',
  },
  alreadyMember: {
    id: 'session.email.already.member',
    defaultMessage: 'Already a member?',
  },
  joinOurCommunity: {
    id: 'session.email.join',
    defaultMessage: 'Join our community',
  },
  defaultWelcomeMessage: {
    id: 'hub.settings.profile.default.welcome.message',
    defaultMessage: `There is no community configured here.{lineBreak} Visit {link} for more information on Communities`,
  },
  signInHere: {
    id: 'session.email.signin',
    defaultMessage: 'Sign in here',
  },
})
